import { styled } from "@mui/material";
import { motion } from "motion/react";

const StyledMotionDiv = styled(motion.div)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  paddingBottom: theme.spacing(4),
}));

function FullWidthPage({ children }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <StyledMotionDiv
      initial={{ opacity: 0 }}
      animate={{
        opacity: 1,
        transition: {
          delay: 0.1,
        },
      }}
    >
      {children}
    </StyledMotionDiv>
  );
}

export default FullWidthPage;
